export default {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler : [
        'res/sound/ballroll',
        'res/sound/ballt',
        'res/sound/bet',
        'res/sound/betreset',
        'res/sound/chcard',
        'res/sound/hfon',
        'res/sound/out_extraball',
        'res/sound/out_free_extraball',
        'res/sound/shuffle',
        'res/sound/sliv',
        'res/sound/speed1',
        'res/sound/speed2',
        'res/sound/speed3',
        'res/sound/speed4',
        'res/sound/speed5',
        'res/sound/zadvijka',
        'res/sound/win/005',
        'res/sound/win/004',
        'res/sound/win/003',
        'res/sound/win/002',
        'res/sound/win/001',
        'res/sound/win/000',
    ],
    //all other different resources (even those which configure the game logic) are able to be ed with PIXI native loader:
    pixi : [
        //main:
        'res/loto_gun.png',
        'res/mainfon.png',
        
        'res/tube_big/000.png',
        'res/tube_big/001.png',
        'res/tube_big/002.png',
        'res/tube_big/003.png',
        'res/tube_big/004.png',
        'res/tube_big/005.png',
        'res/tube_big/006.png',
        'res/tube_big/007.png',
        'res/tube_big/008.png',
        'res/tube_big/009.png',
        
        'res/tube_little/000.png',
        'res/tube_little/001.png',
        'res/tube_little/002.png',
        'res/tube_little/003.png',
        'res/tube_little/004.png',
        'res/tube_little/005.png',
        'res/tube_little/006.png',
        'res/tube_little/007.png',
        'res/tube_little/008.png',
        'res/tube_little/009.png',
        
        'res/balls/000.png',
        'res/balls/001.png',
        'res/balls/002.png',
        'res/balls/003.png',
        'res/balls/004.png',
        'res/balls/005.png',
        'res/balls/006.png',
        'res/balls/007.png',
        'res/balls/008.png',
        'res/balls/009.png',
        'res/balls/010.png',
        'res/balls/011.png',
        'res/balls/012.png',
        'res/balls/013.png',
        'res/balls/014.png',
        'res/balls/015.png',
        'res/balls/016.png',
        'res/balls/017.png',
        'res/balls/018.png',
        'res/balls/019.png',
        'res/balls/020.png',
        'res/balls/021.png',
        'res/balls/022.png',
        'res/balls/023.png',
        'res/balls/024.png',
        'res/balls/025.png',
        'res/balls/026.png',
        'res/balls/027.png',
        'res/balls/028.png',
        'res/balls/029.png',
        'res/balls/030.png',
        'res/balls/031.png',
        'res/balls/032.png',
        'res/balls/033.png',
        'res/balls/034.png',
        'res/balls/035.png',
        'res/balls/036.png',
        'res/balls/037.png',
        'res/balls/038.png',
        'res/balls/039.png',
        'res/balls/040.png',
        'res/balls/041.png',
        'res/balls/042.png',
        'res/balls/043.png',
        'res/balls/044.png',
        'res/balls/045.png',
        'res/balls/046.png',
        'res/balls/047.png',
        'res/balls/048.png',
        'res/balls/049.png',
        'res/balls/050.png',
        'res/balls/051.png',
        'res/balls/052.png',
        'res/balls/053.png',
        'res/balls/054.png',
        'res/balls/055.png',
        'res/balls/056.png',
        'res/balls/057.png',
        'res/balls/058.png',
        'res/balls/059.png',
        'res/balls/060.png',
        'res/balls/061.png',
        'res/balls/062.png',
        'res/balls/063.png',
        'res/balls/064.png',
        'res/balls/065.png',
        'res/balls/066.png',
        'res/balls/067.png',
        'res/balls/068.png',
        'res/balls/069.png',
        'res/balls/070.png',
        'res/balls/071.png',
        'res/balls/072.png',
        'res/balls/073.png',
        'res/balls/074.png',
        'res/balls/075.png',
        'res/balls/076.png',
        'res/balls/077.png',
        'res/balls/078.png',
        'res/balls/079.png',
        'res/balls/080.png',
        'res/balls/081.png',
        'res/balls/082.png',
        'res/balls/083.png',
        'res/balls/084.png',
        'res/balls/085.png',
        'res/balls/086.png',
        'res/balls/087.png',
        'res/balls/088.png',
        'res/balls/089.png',
        
        'res/glass/000.png',
        'res/glass/001.png',
        'res/glass/002.png',
        
        'res/bigballs/000.png',
        'res/bigballs/001.png',
        'res/bigballs/002.png',
        'res/bigballs/003.png',
        'res/bigballs/004.png',
        'res/bigballs/005.png',
        'res/bigballs/006.png',
        'res/bigballs/007.png',
        'res/bigballs/008.png',
        
        'res/font/bet.xml',
        'res/font/bigball_black.xml',
        'res/font/bigball_white.xml',
        'res/font/card_betwin.xml',
        'res/font/card_cell_black.xml',
        'res/font/card_cell_white.xml',
        'res/font/counter_balls.xml',
        'res/font/counter_extraballs.xml',
        'res/font/credit.xml',
        'res/font/possible_win_cell.xml',
        'res/font/price_combination_red.xml',
        'res/font/price_combination_second_display.xml',
        'res/font/price_combination_white.xml',
        'res/font/price_eb.xml',
        'res/font/win.xml',
        
        'res/blocker/000/000.png',
        'res/blocker/000/001.png',
        'res/blocker/000/002.png',
        'res/blocker/000/003.png',
        'res/blocker/000/004.png',
        'res/blocker/001/000.png',
        'res/blocker/001/001.png',
        'res/blocker/001/002.png',
        'res/blocker/001/003.png',
        'res/blocker/001/004.png',
        'res/blocker/002/000.png',
        'res/blocker/002/001.png',
        'res/blocker/002/002.png',
        'res/blocker/002/003.png',
        'res/blocker/002/004.png',
        'res/blocker/003/000.png',
        'res/blocker/003/001.png',
        'res/blocker/003/002.png',
        'res/blocker/003/003.png',
        'res/blocker/003/004.png',
        
        'res/speed/000.png',
        'res/speed/001.png',
        'res/speed/002.png',
        'res/speed/003.png',
        'res/speed/004.png',
        'res/speed/005.png',
        'res/speed/006.png',
        'res/speed/007.png',
        'res/speed/008.png',
        'res/speed/009.png',
        'res/speed/010.png',
        'res/speed/011.png',
        'res/speed/012.png',
        'res/speed/013.png',
        'res/speed/014.png',
        'res/speed/015.png',
        'res/speed/016.png',
        'res/speed/017.png',
        'res/speed/018.png',
        'res/speed/019.png',
        'res/speed/020.png',
        'res/speed/021.png',
        'res/speed/022.png',
        'res/speed/023.png',
        'res/speed/024.png',
        'res/speed/auto.png',
        'res/speed/manual.png',
        
        'res/foreground.png',
        
        'res/collect/000.png',
        'res/collect/001.png',
        'res/collect/002.png',
        'res/collect/003.png',
        'res/collect/004.png',
        'res/collect/005.png',
        'res/collect/006.png',
        'res/collect/007.png',
        'res/collect/008.png',
        'res/collect/009.png',
        
        'res/price_balls/000.png',
        'res/price_balls/001.png',
        
        'res/attention/indicator/000.png',
        'res/attention/indicator/001.png',
        'res/attention/indicator/002.png',
        'res/attention/indicator/003.png',
        'res/attention/indicator/004.png',
        'res/attention/indicator/005.png',
        'res/attention/indicator/006.png',
        'res/attention/indicator/007.png',
        'res/attention/indicator/008.png',
        'res/attention/indicator/009.png',
        'res/attention/indicator/010.png',
        'res/attention/indicator/011.png',
        'res/attention/indicator/012.png',
        'res/attention/indicator/013.png',
        'res/attention/indicator/014.png',
        'res/attention/indicator/015.png',
        'res/attention/indicator/016.png',
        'res/attention/indicator/017.png',
        'res/attention/indicator/018.png',
        'res/attention/indicator/019.png',
        'res/attention/indicator/020.png',
        'res/attention/indicator/021.png',
        'res/attention/indicator/022.png',
        'res/attention/indicator/023.png',
        'res/attention/indicator/024.png',
        'res/attention/indicator/025.png',
        'res/attention/indicator/026.png',
        'res/attention/indicator/027.png',
        'res/attention/indicator/028.png',
        'res/attention/indicator/029.png',
        'res/attention/indicator/030.png',
        'res/attention/indicator/031.png',
        'res/attention/indicator/032.png',
        'res/attention/indicator/033.png',
        'res/attention/indicator/034.png',
        'res/attention/indicator/035.png',
        'res/attention/indicator/036.png',
        'res/attention/indicator/037.png',
        'res/attention/indicator/038.png',
        'res/attention/indicator/039.png',
        
        //cards:
        'res/cards/table.png',
        'res/cards/tabs/000.png',
        'res/cards/tabs/001.png',
        'res/cards/tabs/002.png',
        'res/cards/tabs/003.png',
        'res/cards/colour_blocks/000.png',
        'res/cards/colour_blocks/001.png',
        'res/cards/lines/win/000.png',
        'res/cards/lines/win/001.png',
        'res/cards/lines/win/002.png',
        'res/cards/lines/win/003.png',
        'res/cards/lines/win/004.png',
        'res/cards/lines/win/005.png',
        'res/cards/lines/win/006.png',
        'res/cards/lines/win/007.png',
        'res/cards/lines/win/008.png',
        'res/cards/lines/win/009.png',
        'res/cards/lines/win/010.png',
        'res/cards/lines/win/011.png',
        'res/cards/lines/win/012.png',
        'res/cards/lines/win/013.png',
        'res/cards/lines/win/014.png',
        'res/cards/lines/win/015.png',
        'res/cards/lines/win/016.png',
        'res/cards/lines/win/017.png',
        'res/cards/lines/win/018.png',
        'res/cards/lines/will_be/000.png',
        'res/cards/lines/will_be/001.png',
        'res/cards/lines/will_be/002.png',
        'res/cards/lines/will_be/003.png',
        'res/cards/lines/will_be/004.png',
        'res/cards/lines/will_be/005.png',
        'res/cards/lines/will_be/006.png',
        'res/cards/lines/will_be/007.png',
        'res/cards/lines/will_be/008.png',
        'res/cards/lines/will_be/009.png',
        'res/cards/lines/will_be/010.png',
        'res/cards/lines/will_be/011.png',
        'res/cards/lines/will_be/012.png',
        'res/cards/lines/will_be/013.png',
        'res/cards/lines/will_be/014.png',
        'res/cards/lines/will_be/015.png',
        'res/cards/lines/will_be/016.png',
        'res/cards/lines/will_be/017.png',
        'res/cards/lines/will_be/018.png',
        
        'res/help/000.png',
        'res/help/001.png',
        
        'res/second_display/cell.png',
    ],
}






//////////////////
// WEBPACK FOOTER
// ./res/resources.es6
// module id = 93
// module chunks = 0